import React from 'react';
import MainLayout from '../../components/layout/MainLayout';
import { InsightsWorkspace } from '../insights/InsightsWorkspace';

const Insights: React.FC = () => {
  return (
    <MainLayout title="Insights">
      <InsightsWorkspace />
    </MainLayout>
  );
};

export default Insights; 